import React, { useState } from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";
import Logo from "../../../assets/images/logo.png";
import DesktopService from "./DesktopServices";
import DesktopProduct from "./DesktopProduct";
const DesktopNav = () => {
  const [showServiceDropdown, setShowServiceDropdown] = useState(false);
  const [showQuickLinksDropdown, setShowQuickLinksDropdown] = useState(false);

  return (
    <>
      <div className="flex py-3 justify-between  relative  items-center bg-white px-3  shadow-md  z-20">
        {/* Left Side - Logo */}
        <div className="flex items-center justify-center">
          <Link to="/">
            <img src={Logo} alt="Logo" className=" h-10 w-auto" />
          </Link>
        </div>

        {/* Middle - Navigation Links */}

        <ul className="flex space-x-5 mt-2 cursor-pointer  text-lg   list-none">
          {/* Home */}
          <li className="group relative">
            <div className="relative">
              <Link
                to="/"
                className="hover:text-main font-semibold   text-inherit no-underline"
              >
                Home
              </Link>
              <span className="absolute left-0 bottom-0 w-0 h-[2px] bg-main transition-all duration-300 group-hover:w-full"></span>
            </div>
          </li>

          {/* About */}
          <li className="group relative">
            <div className="relative">
              <Link
                to="/about-us"
                className="hover:text-main font-medium text-inherit no-underline"
              >
                About
              </Link>
              <span className="absolute left-0 bottom-0 w-0 h-[2px] bg-main transition-all duration-300 group-hover:w-full"></span>
            </div>
          </li>

          {/* Feature */}
          <li className="group relative">
            <div className="relative">
              <Link
                to="/feature"
                className="hover:text-main font-medium text-inherit no-underline"
              >
                Feature
              </Link>
              <span className="absolute left-0 bottom-0 w-0 h-[2px] bg-main transition-all duration-300 group-hover:w-full"></span>
            </div>
          </li>

          {/* Our Team */}
          <li className="group relative">
            <div className="relative">
              <Link
                to="/our-team"
                className="hover:text-main font-medium text-inherit no-underline"
              >
                Our Team
              </Link>
              <span className="absolute left-0 bottom-0 w-0 h-[2px] bg-main transition-all duration-300 group-hover:w-full"></span>
            </div>
          </li>

          {/* Services */}
          <li
            className="relative group"
            onMouseEnter={() => setShowServiceDropdown(true)}
            onMouseLeave={() => setShowServiceDropdown(false)}
          >
            <div className="flex items-center gap-1 relative">
              <div className="hover:text-main  font-medium text-inherit no-underline">
                Services
              </div>
              <FontAwesomeIcon
                icon={showServiceDropdown ? faChevronUp : faChevronDown}
                className="ml-1 text-sm transition-transform duration-300 group-hover:text-main"
              />
              <span className="absolute left-0 bottom-0 w-0 h-[2px] bg-main transition-all duration-300 group-hover:w-full"></span>
            </div>
            {showServiceDropdown && (
              <div className="absolute left-[-30px]  ">
                <DesktopService />
              </div>
            )}
          </li>

          {/* Products */}
          <li
            className="relative group"
            onMouseEnter={() => setShowQuickLinksDropdown(true)}
            onMouseLeave={() => setShowQuickLinksDropdown(false)}
          >
            <div className="flex items-center gap-1 relative">
              <div className="hover:text-main  font-medium text-inherit  no-underline">
                Products
              </div>
              <FontAwesomeIcon
                icon={showQuickLinksDropdown ? faChevronUp : faChevronDown}
                className="pl-1 text-sm transition-transform duration-300 group-hover:text-main"
              />
              <span className="absolute left-0 bottom-0 w-0 h-[2px] bg-main transition-all duration-300 group-hover:w-full"></span>
            </div>
            {showQuickLinksDropdown && (
              <div className="absolute left-[-30px] ">
                <DesktopProduct />
              </div>
            )}
          </li>

          {/* Career */}
          <li className="group relative">
            <div className="relative">
              <Link
                to="/career"
                className="hover:text-main font-medium text-inherit no-underline"
              >
                Career
              </Link>
              <span className="absolute left-0 bottom-0 w-0 h-[2px] bg-main transition-all duration-300 group-hover:w-full"></span>
            </div>
          </li>

          {/* Contact Us */}
          <li className="group relative">
            <div className="relative">
              <Link
                to="/contact-us"
                className="hover:text-main  font-medium text-inherit no-underline"
              >
                Contact Us
              </Link>
              <span className="absolute left-0  bottom-0 w-0 h-[2px] bg-main transition-all duration-300 group-hover:w-full"></span>
            </div>
          </li>

          {/* Payment */}
          <li className="group relative">
            <div className="relative">
              <Link
                to="/payment"
                className="hover:text-main  font-medium text-inherit no-underline"
              >
                Payment
              </Link>
              <span className="absolute left-0  bottom-0 w-0 h-[2px] bg-main transition-all duration-300 group-hover:w-full"></span>
            </div>
          </li>
        </ul>

        <div className="flex items-center space-x-4">
          {/* Request A Call Back */}
          <Link to="/contact-us">
            <button className="  bg-orangeheading text-white font-medium py-[10px] px-[15px] text-[14px] rounded-full shadow-md hover:bg-orange-500 hover:shadow-lg transition-all duration-300 no-underline">
              Enquiry Now
            </button>
          </Link>
        </div>
      </div>
    </>
  );
};

export default DesktopNav;
